module.exports = "/images/icon_register_black.svg?e08490ca9997ff92714b0329addd7a3a";